import { alpha, GlobalStyles, type PaletteColor } from "@mui/material";

interface ExtendedPaletteColor extends PaletteColor {
  ultraLight?: string;
  contrastTextUltraLight?: string;
}

export function BackofficeGlobalStyles() {
  return (
    <GlobalStyles
      styles={(theme) => {
        const primary = theme.palette.primary as ExtendedPaletteColor;

        return {
          ":root": {
            "--backoffice-background-default": theme.palette.background.default,
            "--backoffice-background-paper": theme.palette.background.paper,
            "--backoffice-background-paper-translucent": alpha(theme.palette.background.paper, 0.5),
            "--backoffice-background-muted": theme.palette.action.hover,
            "--backoffice-text-primary": theme.palette.text.primary,
            "--backoffice-text-secondary": theme.palette.text.secondary,
            "--backoffice-text-disabled": theme.palette.text.disabled,
            "--backoffice-divider": theme.palette.divider,
            "--backoffice-action-hover": theme.palette.action.hover,
            "--backoffice-action-selected": theme.palette.action.selected,
            "--backoffice-primary-main": primary.main,
            "--backoffice-primary-light": primary.light,
            "--backoffice-primary-ultra-light": primary.ultraLight ?? primary.light,
            "--backoffice-primary-contrast": primary.contrastText,
            "--backoffice-primary-ultra-light-contrast": primary.contrastTextUltraLight ?? primary.contrastText,
            "--backoffice-error-main": theme.palette.error.main,
            "--backoffice-shadow": theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.45)" : "rgba(0, 0, 0, 0.1)",
            "--autovio-color-black": theme.palette.text.primary,
            "--autovio-color-white": theme.palette.background.paper,
            "--autovio-color-grey": theme.palette.text.secondary,
            "--autovio-color-greyLight": theme.palette.divider,
            "--autovio-color-greyUltraLight": theme.palette.action.hover,
            "--autovio-color-borderGrey": theme.palette.divider,
          },
          body: {
            backgroundColor: "var(--backoffice-background-default)",
            color: theme.palette.text.primary,
          },
        };
      }}
    />
  );
}
